import { Component, ContentChildren, EventEmitter, Output, QueryList, Input } from '@angular/core';
import { Route } from '@bca-shared/models/_enums';
import { TabComponent } from './tab/tab.component';

@Component({
  selector: 'bca-tab-stepper',
  templateUrl: 'tab-stepper.component.html',
  styleUrls: ['tab-stepper.component.scss']
})
export class TabStepperComponent {
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Input() highestRoute: number;
  @Input() currentRoute: number;
  @Output() tabClicked = new EventEmitter<TabComponent>();

  Route = Route;
}
